import { render, staticRenderFns } from "./edit-testQuestion.vue?vue&type=template&id=05cf9137&scoped=true&"
import script from "./edit-testQuestion.vue?vue&type=script&lang=ts&"
export * from "./edit-testQuestion.vue?vue&type=script&lang=ts&"
import style0 from "./edit-testQuestion.vue?vue&type=style&index=0&id=05cf9137&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf9137",
  null
  
)

export default component.exports